<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商品管理
      <small>/&nbsp;系列管理</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">系列管理列表</h4>
              </div>
              <!-- end panel-heading -->
              <!-- begin panel-body -->
              <div class="panel-body">
                <form style="margin-top:16px;padding-left:15px;">
                  <fieldset>
                    <div class="form-group row m-b-15">
                      <label class="col-md-1 col-form-label">品牌名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="BrandList"
                          key-field="brandId"
                          show-field="brandName"
                          placeholder="品牌名称"
                          v-model="brandId"
                          @values="BrandChange"
                          title
                        ></v-selectpage>
                      </div>
                      <label class="col-md-1 col-form-label">系列名称</label>
                      <div class="col-md-2">
                        <v-selectpage
                          :data="SeriesList"
                          key-field="seriesId"
                          show-field="seriesName"
                          placeholder="系列名称"
                          v-model="seriesId"
                          title
                        ></v-selectpage>
                      </div>

                      <div class="col-md-1">
                        <a
                          class="btn btn-primary ButtonColor m-r-5"
                          @click="SearchClick()"
                          style="float:right;"
                        >查询</a>
                      </div>
                      <div class="col-md-5"></div>
                      <div class="col-md-11"></div>
                      <div class="col-md-1">
                        <a
                          class="btn btn-primary ButtonColor"
                          @click="AddClick()"
                          style="float:right;"
                        >新增</a>
                      </div>
                    </div>
                    <div class="form-group row m-b-15"></div>
                  </fieldset>
                </form>

                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column prop="brandCode" label="品牌编号" align="center"></el-table-column>
                  <el-table-column prop="brandName" label="品牌名称" align="center"></el-table-column>
                  <el-table-column prop="seriesCode" label="系列编号" align="center"></el-table-column>
                  <el-table-column prop="seriesName" label="系列名称" align="center"></el-table-column>

                  <el-table-column label="操作" width="140" align="center">
                    <template slot-scope="scope">
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        :disabled="scope.row.disabled"
                        @click="EditClick(scope.row)"
                      >编辑</button>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        :disabled="scope.row.disabled"
                        @click="DeleteClick(scope.row)"
                      >删除</button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
              <div style="height:64px;padding-top:8px;padding-right:16px;" v-if="BackShow">
                <a class="btn btn-primary m-r-5 BackButton" @click="GoBack">返&nbsp;&nbsp;回</a>

                <span class="clear"></span>
              </div>
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="500px" :before-close="handleClose">
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSure"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="所属品牌:" prop="brandId">
            <el-select
              v-model="ruleForm.brandId"
              placeholder="请选择"
              class="DistributorMargin"
              style="width:100%"
              filterable
            >
              <el-option
                v-for="item in BrandOptions"
                :key="item.brandId"
                :label="item.brandName"
                :value="item.brandId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="系列名称:" prop="seriesName">
            <el-input v-model="ruleForm.seriesName" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="系列编号:" prop="seriesCode">
            <el-input v-model="ruleForm.seriesCode" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="noted">
            <el-input type="textarea" v-model="ruleForm.noted" class="DistributorMargin"></el-input>
          </el-form-item>
        </el-form>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled="disabled"
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "SeriesManagement",
  data() {
    var checkseriesCode = (rule, value, callback) => {
      setTimeout(() => {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error("系列编号不能输入汉字"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkseries = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("系列名称不能为空"));
      }
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("系列名称不能大于32个字符"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checknoted = (rule, value, callback) => {
      setTimeout(() => {
        if (
          value !== "" &&
          value !== undefined &&
          value !== null &&
          value.length > 128
        ) {
          callback(new Error("备注不能超过128个字符"));
        } else {
          callback();
        }
      }, 1000);
    };
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      DialogTitle: "编辑",
      EditDialog: 1,
      CurrentSelection: [],
      fuzzy: "",
      status: "1",
      brandId: "",
      seriesId: "",
      seriesName:"",
      SeriesList: [],
      BrandList: [],
      CloseShow: false,
      BackShow: false,
      disabled: false,
      BrandOptions: [],
      StateOptions: [
        {
          label: "删除",
          value: 0
        },
        {
          label: "正常",
          value: 1
        }
      ],
      ruleForm: {
        seriesCode: "",
        seriesName: "",
        brandId: "",
        noted: ""
      },
      rules: {
        seriesCode: [
          { required: false, validator: checkseriesCode, trigger: "blur" }
        ],
        seriesName: [
          { required: true, message: "请输入商品系列名称", trigger: "blur" },
          { validator: checkseries, trigger: "blur" }
        ],
        brandId: [
          { required: true, message: "请输入所属品牌id", trigger: "blur" }
        ],
        noted: [{ required: false, validator: checknoted, trigger: "blur" }]
      },
      UserManagementEdit: "",
      TimeValue: "",
      UserManagementList: [],
      currentPage: 1,
      LastPageIndex: 1,
      LastpageSize: 10,
      searchContent: {}
    };
  },
  mounted: function() {
    if (this.$route.query.brandId) {
      this.brandId = this.$route.query.brandId.toString();
      this.BackShow = true;
      this.LastPageIndex = this.$route.query.pageIndex;
      this.LastpageSize = this.$route.query.pageSize;
      this.searchContent = JSON.parse(this.$route.query.searchContent);
    } else {
      this.BackShow = false;
    }
    this.initdata();
    this.getBrandInfo();
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },

    getBrandInfo() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsBrandController/queryBrandIdAndName",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.BrandList = response.data.data;
            that.BrandOptions = response.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    BrandChange(val) {
      if (val.length !== 0) {
        let that = this;
        const options = {
          url: "distribution/B2cGoodsInfoController/cascadeQuery",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            brandId: that.brandId
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.SeriesList = response.data.data;
            } else {
              http.handleEorrorCode(response, that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      } else {
        this.brandId = "";
        this.seriesId = "";
        this.SeriesList = [];
      }
    },
    EditClick(row) {
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm = MethodsBus.cloneRow(row);
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    AddClick() {
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.outerVisible = true;

      this.DialogTitle = "新增";
      this.EditDialog = 1;
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },

    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cGoodsSeriesController/updateGoodsSeries",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                seriesId: this.ruleForm.seriesId,
                seriesCode: this.ruleForm.seriesCode,
                seriesName: this.ruleForm.seriesName.replace(/\s+/g, ""),
                brandId: this.ruleForm.brandId,
                noted: this.ruleForm.noted
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: "修改成功",
                    type: "success"
                  });
                } else {
                  that.outerVisible = false;
                  that.disabled = false;
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cGoodsSeriesController/addGoodsSeries",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                seriesCode: this.ruleForm.seriesCode,
                seriesName: this.ruleForm.seriesName.replace(/\s+/g, ""),
                brandId: this.ruleForm.brandId,
                noted: this.ruleForm.noted
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: "新增成功",
                    type: "success"
                  });
                } else {
                  that.outerVisible = false;
                  that.disabled = false;
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      axios
        .post(
          "distribution/B2cGoodsSeriesController/delGoodsSeries?seriesId=" +
            this.CurrentSelection.seriesId
        )
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          that.initdata();
          if (response.data.code == 200) {
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            that.outerVisible = false;
            that.disabled = false;
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.outerVisible = false;
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    GoBack() {
      eventBus.$emit("SeriesBackEmit", true);
      this.$router.push({
        name: "BrandManagement",
        params: {
          pageNo: this.LastPageIndex,
          pagesize: this.LastpageSize,
          searchContent: this.searchContent
        }
      });
    },
    initdata() {
      let that = this;

      const options = {
        url: "distribution/B2cGoodsSeriesController/queryGoodsSeries",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          brandId: that.brandId,
          seriesId: that.seriesId,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.totalCount = response.data.data.totalCount;
            for (var i in response.data.data.data) {
              response.data.data.data[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            }

            that.UserManagementList = response.data.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.BackButton {
  float: right;
  cursor: pointer;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CommoditiesList/SeriesManagement.vue